import { BrandMark } from "@mattfinkel/common-web";
import { Link, Outlet } from "react-router";

export function Layout({ email, onSignOut }: { email: string | null; onSignOut: () => void }) {
  return (
    <div className="mx-auto min-h-screen w-full max-w-4xl px-4 pb-16 sm:px-8">
      <header className="flex items-center justify-between py-6">
        <Link to="/" className="flex items-center gap-3">
          <BrandMark brand="me" alt="" className="h-10 w-10 rounded-xl shadow-sm" />
          <span>
            <span className="block text-sm font-semibold text-ink">Home</span>
            <span className="block text-xs text-ink-muted">Matt&apos;s apps</span>
          </span>
        </Link>
        <div className="text-right">
          {email && <p className="hidden text-xs text-ink-muted sm:block">{email}</p>}
          <button type="button" onClick={onSignOut} className="text-xs text-ink-muted hover:text-ink">
            Sign out
          </button>
        </div>
      </header>
      <main className="pt-8"><Outlet /></main>
    </div>
  );
}
